import { jsx as _jsx } from "react/jsx-runtime";
import { Tag } from "antd";
function useReleaseOverViewColumns(t) {
    return [
        {
            title: t("Release Number"),
            dataIndex: "id",
            render: (id)=>{
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(Tag, {
                        style: {
                            width: "5rem",
                            textAlign: "center"
                        },
                        color: "blue",
                        children: id
                    })
                });
            },
            sorter: (a, b)=>Number(a.id) - Number(b.id)
        },
        {
            title: t("Release Date"),
            dataIndex: "createdAt",
            render: (createdAt)=>{
                const dateTime = new Date(createdAt);
                return /*#__PURE__*/ _jsx("div", {
                    children: formatHumanReadableDate(dateTime)
                });
            },
            sorter: (a, b)=>{
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return dateA.toISOString().localeCompare(dateB.toISOString());
            }
        }
    ];
}
function formatHumanReadableDate(date) {
    const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
}
export { useReleaseOverViewColumns };
